import React, { ReactNode } from 'react'

import s from './styles.module.scss'

export interface IDefinitionTable {
  title: ReactNode
  subTitle?: string
  description: string | React.ReactNode
}

const DefinitionTable = ({
  tableContent,
}: {
  tableContent: IDefinitionTable[]
}) => {
  return (
    <div className={s.grid}>
      {tableContent.map((item, index) => (
        <React.Fragment key={index}>
          <div>
            <p>{item.title}</p>
            <p className={s.subTitle}>{item.subTitle}</p>
          </div>

          <div>{item.description}</div>
        </React.Fragment>
      ))}
    </div>
  )
}
export default DefinitionTable
